import {
  formatDetailValue,
  getContractDetailPicklistLabel,
} from "@features/projects-feature/projectHelpers";
import { ContractDto } from "@lib/ShiOneClient";
import { Box, Typography } from "@mui/material";
import React from "react";
import { ContractDetailTextFieldProps } from "@features/projects-feature/projectTypes";

export const ContractDetailTextField = ({
  field,
  contract,
  picklist,
}: ContractDetailTextFieldProps) => {
  const value = field.isPicklist
    ? getContractDetailPicklistLabel(field, contract, picklist)
    : formatDetailValue(
        contract[field.fieldKey as keyof ContractDto],
        field.type,
      );

  return (
    <Box
      sx={{
        "& :hover": {
          borderLeft: (theme) => "2px solid" + theme.palette.secondary.dark,
        },
        "& div": {
          "& :hover": {
            borderLeft: "0px",
          },
        },
      }}
    >
      <Box pl={2} mb={2} borderLeft={"2px solid transparent"}>
        <Typography variant="caption" color="text.secondary" component="div">
          {field.label}
        </Typography>
        <Typography
          variant="body1"
          color="text.primary"
          component="div"
          sx={{ maxHeight: 40, overflow: "auto" }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};
